import {
    useContext,
    useEffect,
    useState
} from 'react'
import {
    Button,
    Divider,
    Flex,
    Modal,
    Space,
    Table
} from 'antd';
import {
    useMutation,
    useQuery
} from '@apollo/client';
import {
    NotificationContext
} from '../../context/notification-provider';
import {
    ExclamationCircleFilled
} from '@ant-design/icons';
import { useSelector } from "react-redux";
import { selectRestaurant } from '../../store/selectors/user.selector';
import { DELETE_TIME_SLOT } from '../../apollo/mutation/time-slot.mutation';
import { RETRIEVE_TIME_SLOTS } from '../../apollo/query/time-slot.query';
import TimeSlotDetail from '../../components/time-slot-detail';

const { confirm } = Modal;

const TimeSlots = () => {
    /** State to manage the visibility of the subcategory detail */
    const [visible, setVisible] = useState<number | null>(null);
    /** Retrieve the restaurant ID */
    const restaurant = useSelector(selectRestaurant);
    /** Notification utilities */
    const { showNotification } = useContext(NotificationContext);
    /** Request the list of subcategories */
    const { data } = useQuery(RETRIEVE_TIME_SLOTS, { variables: { nIDRestaurant: restaurant?.nID } });
    /** Request the deletion of the subcategory */
    const [ deleteTimeSlot, { data: responseDeletion } ] = useMutation(DELETE_TIME_SLOT, { refetchQueries: ['gqlRetrieveTimeSlots']} );
    
    /** Manage to display the alert of deletion succeed */
    useEffect((): void => {
        if( responseDeletion?.code === 200 ) {
            showNotification({ severity: 'success', title: 'Franja Horaria eliminada.' });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseDeletion]);
    
    /** Manage to delete the specific subcategory */
    const onDelete = (nID: number): void => {
        confirm({
            title: 'Estàs segur d\'eliminar aquesta franja horaria?',
            icon: <ExclamationCircleFilled />,
            okText: 'Confirmar',
            onOk() {
                deleteTimeSlot({ variables: { nID: nID } });
            },
            cancelText: 'Cancel·lar'
        });
    }

    const columns = [
        {
            title: 'Hora Inici',
            dataIndex: 'tStart',
            key: 'tStart',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: 'Hora Final',
            dataIndex: 'tEnd',
            key: 'tEnd',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: 'Numero màxim reserves',
            dataIndex: 'nLimit',
            key: 'nLimit',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: '',
            key: 'action',
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type='text' danger onClick={(evt: any) => {
                        onDelete(record.nID);
                        evt.stopPropagation();
                    }}> Eliminar </Button>
                </Space>
            )
        }
    ];
    
    return (
        <Flex vertical style={{ backgroundColor: 'white', height: '100%', padding: 10 }}>
            <Flex justify='flex-end'>
                <Button type='primary' onClick={() => setVisible(-1)}> Afegir Franja Horaria </Button>
            </Flex>
            <Divider />
            <Flex style={{ width: '100%' }}>
                <Table
                    columns={columns}
                    dataSource={data?.data}
                    rowKey={(record: any) => record.nID}
                    style={{ width: '100%' }}
                    onRow={(record) => {
                        return {
                            onClick: () => setVisible(record.nID)
                        };
                    }}
                    pagination={false}
                />
            </Flex>
            <TimeSlotDetail id={visible} visible={visible} setVisible={setVisible} />
        </Flex>
    );
}

export default TimeSlots;